import { render, staticRenderFns } from "./CommentShareModal.vue?vue&type=template&id=267912a4"
import script from "./CommentShareModal.vue?vue&type=script&lang=js"
export * from "./CommentShareModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports